var _g, _path, _g2, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconePuerperio = function SvgIconePuerperio(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_14652_31391)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 17,
    r: 16,
    fill: "#ECF0FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1367 17.8518C17.5905 15.4196 17.704 14.8116 19.4437 15.3578C21.1833 15.904 19.1205 19.0877 18.5955 20.6087C19.6085 20.467 20.3142 21.2698 20.9617 21.8875C21.4768 22.3788 21.3445 22.7437 21.992 23.3614C22.5071 23.8529 22.2784 24.9882 21.992 25.8178C21.7057 26.6475 20.8014 24.1257 19.9315 23.8526C19.0617 23.5795 19.6194 23.229 17.4448 22.5463C15.2702 21.8635 16.5695 20.8922 17.1367 17.8519L17.1367 17.8518Z",
    fill: "#C5D4FF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_14652_31391)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.8057 13.1391C21.2709 12.3771 21.6372 10.5991 21.6372 9.80536C18.3405 10.1864 15.868 10.4783 15.4101 15.2822L18.6152 15.719C18.0197 14.6781 17.7155 13.6978 18.0197 13.6722C18.5266 13.6296 19.1444 13.4831 19.8057 13.1391Z",
    fill: "#C5D4FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.306 10.4134C18.5749 10.7993 16.3198 11.3021 16.3198 12.0768C16.3198 13.3915 15.3825 14.2468 14.0304 13.387C12.6782 12.5272 13.5153 9.94784 15.0606 10.4392C15.0606 10.408 15.0605 10.3761 15.0603 10.3434C15.0565 9.45905 15.0504 8.02738 17.6997 7.18517C19.9916 6.45657 21.3275 8.02598 21.7074 9.3219C21.8299 9.73988 21.5389 10.1287 21.1151 10.2294C20.8686 10.2879 20.5946 10.349 20.306 10.4134ZM18.3038 15.2139C17.7598 14.7316 16.9338 13.9992 15.868 14.6092C14.5891 15.3412 15.0249 16.3457 15.5788 17.6228C16.0165 18.6318 16.528 19.8109 16.3259 21.1602C16.1332 22.4468 15.8053 23.5459 15.4489 24.3834C15.0399 25.3443 14.9117 26.694 15.7775 27.2781C16.5779 27.818 17.7952 28.1049 20.3533 27.9646C22.1211 27.8677 21.6542 26.0957 21.1323 24.1152C20.6772 22.3883 20.1804 20.5028 21.0868 19.431C21.3921 18.8487 21.73 18.0793 20.5717 16.9744C20.4141 16.8241 20.3412 16.748 20.2635 16.6772C20.0874 16.5168 19.8862 16.3838 18.6153 15.4746C18.5248 15.4099 18.4208 15.3177 18.3038 15.2139Z",
    fill: "#498FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0764 17.8518C15.5302 15.4196 15.6437 14.8115 17.3834 15.3577C19.123 15.9039 17.0602 19.0876 16.5352 20.6086C17.5482 20.4669 19.2842 21.7608 19.9317 22.3784C20.4467 22.8698 20.8296 22.7436 21.477 23.3613C21.9922 23.8528 22.2784 24.988 21.9921 25.8176C21.7058 26.6472 20.8014 24.1255 19.9316 23.8524C19.0618 23.5793 17.5591 23.2289 15.3845 22.5462C13.2099 21.8634 14.5092 20.8921 15.0764 17.8518Z",
    fill: "#C5D4FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_14652_31391",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.772549 0 0 0 0 0.831373 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14652_31391"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14652_31391",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_14652_31391",
    x: 12.3516,
    y: 6,
    width: 10.7539,
    height: 23,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.286275 0 0 0 0 0.560784 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_14652_31391"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_14652_31391",
    result: "shape"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconePuerperio, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icone-puerperio.0a6a6582.svg";
export { ForwardRef as ReactComponent };